export enum PageTypeEnum {
  Inline = 'inline',
  Popup = 'popup',
  Squeeze = 'squeeze',
  SalesPage = 'sales_page',
  Lecture = 'lecture',
  WebinarSession = 'webinar_session',
  WebinarRegistration = 'webinar_registration',
  WebinarThankYou = 'webinar_thank_you_page',
  InfoPage = 'info_page',
  OptInThankYou = 'opt_in_thank_you',
  OfferPage = 'offer_page',
  OfferUpSellPage = 'offer_upsell_page',
  OfferDownSellPage = 'offer_downsell_page',
  InactiveFunnelPage = 'inactive_funnel_page',
  OfferThankYouPage = 'offer_thank_you_page',
  OfferInnerThankYouPage = 'offer_inner_thank_you',
  OfferInner = 'offer_inner',
  CustomLogin = 'custom_login',
  BlogPostLayout = 'blog_post_layout',
  BlogPostBody = 'blog_post_body',
  BlogLayout = 'blog_layout',
  BlogStatic = 'blog_static',
  BlogHome = 'blog_home',
  BlogSearch = 'blog_search',
  BlogPostListing = 'blog_post_listing',
  CourseIntroduction = 'course_introduction',
  FunnelContactUs = 'funnel_contact_us',
  NotFound = 'not_found',
  LinkInBio = 'link_in_bio',
  BookingCalendarPreview = 'booking_calendar_preview',

  // website page types
  WebsiteLayout = 'WebsiteLayout',
  WebsiteDefault = 'WebsiteDefault',
  WebsiteHome = 'WebsiteHome',
  WebsitePricing = 'WebsitePricing',
  WebsiteLogin = 'WebsiteLogin',
  WebsiteSearch = 'WebsiteSearch',
  WebsitePublicPage = 'WebsitePublicPage',

  // website blog page types
  WebsiteBlogHome = 'WebsiteBlogHome',
  WebsiteBlogPostListing = 'WebsiteBlogPostListing',
  WebsiteBlogPost = 'WebsiteBlogPost',
  WebsiteBlogPostLayout = 'WebsiteBlogPostLayout',
  WebsiteBlogCategory = 'WebsiteBlogCategory',
}

export type WebsitePageType = (typeof websitePageTypes)[number]

export const websitePageTypes = [
  PageTypeEnum.WebsiteLayout,
  PageTypeEnum.WebsiteDefault,
  PageTypeEnum.WebsiteHome,
  PageTypeEnum.WebsitePricing,
  PageTypeEnum.WebsiteLogin,
  PageTypeEnum.WebsiteBlogHome,
  PageTypeEnum.WebsiteBlogPostListing,
  PageTypeEnum.WebsiteBlogPost,
  PageTypeEnum.WebsiteBlogPostLayout,
  PageTypeEnum.WebsiteBlogCategory,
  PageTypeEnum.WebsiteSearch,
] as const

export type BlogPageType = (typeof blogPageTypes)[number]

export const blogPageTypes = [
  PageTypeEnum.BlogHome,
  PageTypeEnum.BlogPostBody,
  PageTypeEnum.BlogPostListing,
  PageTypeEnum.BlogStatic,
  PageTypeEnum.BlogPostLayout,
  PageTypeEnum.BlogSearch,
] as const

export const websiteUtilityPages = [
  PageTypeEnum.WebsiteLogin,
  PageTypeEnum.NotFound,
  PageTypeEnum.WebsiteSearch,
  // PageTypeEnum.WebsiteContactUs, TODO: to be added when website contact-us page is implemented
] as const

export type WebsiteUtilityPageType = (typeof websiteUtilityPages)[number]
